import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { DataProviderCache } from '../../data/DataProviders/DataProviderCache';
import { SierraChildDeviceDetailsProvider } from '../../data/DataProviders/SierraChildDeviceDetailsProvider';
import { SierraGatewayDeviceDetailsProvider } from '../../data/DataProviders/SierraGatewayDeviceDetailsProvider';
import { DeviceDetailsProvider } from '../../data/DataProviders/DeviceDetailsProvider';
import { useCurrentAppRoute } from '../../hooks/app-route-hooks';
import { AppRoutes } from '../../routes';
import { ChildDeviceProfile } from './ChildDeviceProfile';
import { PxChildDeviceProfile } from './PxChildDeviceProfile';
import { DeviceProfileContainer } from './DeviceProfileContainer';
import { StarfishChildDeviceProfile } from './StarfishChildDeviceProfile';
import { StarfishChildDeviceDetailsProvider } from '../../data/DataProviders/StarfishChildDeviceDetailsProvider';

export const DeviceManagement: React.FC = () => {
    const currentAppRoute = useCurrentAppRoute();

    return (
        <Switch>
            <Route
                exact
                path={[
                    AppRoutes.ChildDeviceProfile,
                    AppRoutes.EditDeviceProfile,
                    AppRoutes.PxChildDeviceProfile,
                    AppRoutes.StarfishChildDeviceProfile,
                    AppRoutes.EditStarfishChildDevice,
                ]}
            >
                {(currentAppRoute.type === 'ChildDeviceProfile' || currentAppRoute.type === 'EditDeviceProfile') && (
                    <>
                        <DataProviderCache for={'ChildProfileData'}>
                            <SierraChildDeviceDetailsProvider
                                deviceId={currentAppRoute.deviceId}
                                siteId={currentAppRoute.siteId}
                                childDeviceId={currentAppRoute.childDeviceId}
                            >
                                <SierraGatewayDeviceDetailsProvider
                                    deviceId={currentAppRoute.deviceId}
                                    siteId={currentAppRoute.siteId}
                                >
                                    <ChildDeviceProfile />
                                </SierraGatewayDeviceDetailsProvider>
                            </SierraChildDeviceDetailsProvider>
                        </DataProviderCache>
                    </>
                )}

                {currentAppRoute.type === 'PxChildDeviceProfile' && (
                    <>
                        <DataProviderCache for={'PxChildProfileData'}>
                            <DeviceDetailsProvider deviceId={currentAppRoute.childDeviceId} recursive={false}>
                                <PxChildDeviceProfile />
                            </DeviceDetailsProvider>
                        </DataProviderCache>
                    </>
                )}
                {(currentAppRoute.type === 'StarfishChildDeviceProfile' ||
                    currentAppRoute.type === 'EditStarfishChildDevice') && (
                    <>
                        <DataProviderCache for={'StarfishChildDeviceProfileData'}>
                            <StarfishChildDeviceDetailsProvider deviceId={currentAppRoute.childDeviceId}>
                                <StarfishChildDeviceProfile />
                            </StarfishChildDeviceDetailsProvider>
                        </DataProviderCache>
                    </>
                )}
            </Route>
            <Route
                path={[
                    AppRoutes.StarfishDeviceProfile,
                    AppRoutes.DeviceProfile,
                    AppRoutes.PxDeviceProfile,
                    AppRoutes.EditConnectedDevice,
                    AppRoutes.EditStarfishChildDevice,
                    AppRoutes.MeshDeviceProfile,
                    AppRoutes.AcquireSubscription,
                ]}
                component={DeviceProfileContainer}
            />
        </Switch>
    );
};
